import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCostItem/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCostItem',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCostItem',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCostItem/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCostItem',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/base/baseCostItem/listOption',
    method: 'get',
    params
  })
}